import { render } from "react-dom";
import React from "react";
import { PageBase } from "../PageBase";
import { GenericHeader } from "../Components/Header/GenericHeader";
import { SigningModal } from "../Components/Signing/SigningModal";
import ReviewPopup from "Components/Review/ReviewPopup";
import assertContainerElement from "Utils/assertContainerElement";

export function initHeader() {
   const root = document.getElementById("header-wrapper");
   assertContainerElement(root);

   const className = root.dataset["classname"] ?? undefined;
   // const fluid = JSON.parse(root.dataset["fluid"]! ?? null);
   const noSearchDataset = root.dataset["nosearch"];
   const redirectToMyLiquidSpaceAfterSignInDataset = root.dataset["redirecttomyliquidspaceaftersignin"];

   const noSearch = noSearchDataset ? JSON.parse(noSearchDataset) : undefined;
   const redirectToMyLiquidSpaceAfterSignIn = redirectToMyLiquidSpaceAfterSignInDataset ? JSON.parse(redirectToMyLiquidSpaceAfterSignInDataset) : undefined;


   render(<PageBase>
      <GenericHeader className={className} fluid={true} noSearch={noSearch} redirectToMyLiquidSpaceAfterSignIn={redirectToMyLiquidSpaceAfterSignIn} />
      <SigningModal />
      <ReviewPopup />
   </PageBase>, root);
}